import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { find } from 'lodash'

import { apolloService } from '../../common/services'

import { DELETE_SOP_MUTATION } from '../graphql/mutations'
import { DELETE_SOP } from '../redux/action-types'

const useDeleteSopMutation = () => {
  const dispatch = useDispatch()
  const { data } = useSelector(store => store.sops.sops)

  const [currentlyDeletingId, setCurrentlyDeletingId] = useState(null)
  const { isDeleting = false, deletingError = undefined } = useMemo(
    () => find(data, sop => sop.id === currentlyDeletingId) || {},
    [currentlyDeletingId, data],
  )

  const mutate = useCallback(
    id => {
      setCurrentlyDeletingId(id)
      apolloService.mutate({
        mutation: DELETE_SOP_MUTATION,
        variables: { id },
        dispatch,
        action: DELETE_SOP,
        onSuccess: () => {
          setCurrentlyDeletingId(null)
        },
      })
    },
    [dispatch],
  )

  return [mutate, { isLoading: isDeleting, error: deletingError }]
}

export default useDeleteSopMutation
